import defense from "../assets/symbols/defense.png";
import intellect from "../assets/symbols/intelect.png";
import life from "../assets/symbols/life.png";
import power from "../assets/symbols/power.png";
import resource from "../assets/symbols/pitch.png";
import tap from "../assets/symbols/tap.webp";
import untap from "../assets/symbols/untap.webp";

export interface FabSymbol {
  src: string;
  label: string;
}

/**
 * Card-text placeholders -> bundled FAB symbols (the-fab-cube `icon.csv`).
 *
 * Keyed by lowercased token so both `{i}` and the canonical `{I}` resolve to
 * Intellect. Tokens still without an asset (`{c}` chi, `{x}` variable cost) are
 * left as literal text until an asset is added here.
 */
export const FAB_SYMBOLS: Record<string, FabSymbol> = {
  p: { src: power, label: "Power" },
  r: { src: resource, label: "Resource point" },
  d: { src: defense, label: "Defense" },
  h: { src: life, label: "Life" },
  i: { src: intellect, label: "Intellect" },
  t: { src: tap, label: "Tap" },
  u: { src: untap, label: "Untap" },
};
